import { tourFiltersToQuery } from '../../model/tour/TourAdapters';
import type { TTourFiltersPageState, TTourFiltersState } from '../../types/tour/state';

/**
 * Базовые поля запроса в том же виде, что для {@link getExperiencesCount} / {@link TourUseFiltersTotalCount}.
 * Не включает exclude_needs_license — его подмешивают вызывающие (count / агрегация в queryFn).
 */
export function buildTourExperiencesCountAlignedQuery(
  searchState: TTourFiltersState,
  pageParams: TTourFiltersPageState,
) {
  const queryParams = tourFiltersToQuery(searchState, pageParams);

  return {
    ...queryParams,
    date_filter_mode:
      queryParams?.type === 'tour' && (queryParams?.start_date || queryParams?.end_date)
        ? 'event_date_range'
        : 'event_start',
    extended_movement_types: true,
  };
}
